import type { PlatformSettings } from "@lightningjs/sdk";

export const platformSettings: PlatformSettings = {
  esEnv: "es5",
  log: true,
  path: "./static",
  plugins: {},
  router: {
    destroyOnHistoryBack: true,
    gcOnUnload: true,
    lazyCreate: true,
    reuseInstance: true,
    updateHash: false,
  },
  showFps: false,
  showVersion: false,
};

export default platformSettings;
